export default [
     {
          id: 1,
          staffName: "Khalid maha",
          staffImg: "../images/rec5.png",
          staffPosition: "Genral",
          staffView: "view Profile",
     },
     {
          id: 2,
          staffName: "Elena jones",
          staffImg: "../images/rec6.png",
          staffPosition: "Surgical",
          staffView: "view Profile",


     },
     {
          id: 3,
          staffName: "Richard kayy",
          staffImg: "../images/rec7.png",
          staffPosition: "Gynacology",
          staffView: "view Profile",
     },
     {
          id: 4,
          staffName: "Richard kayy",
          staffImg: "../images/rec7.png",
          staffPosition: "Gynacology",
          staffView: "view Profile",
     },
     {
          id: 5,
          staffName: "Khalid maha",
          staffImg: "../images/rec5.png",
          staffPosition: "Genral",
          staffView: "view Profile",
     },
     {
          id: 6,
          staffName: "Elena jones",
          staffImg: "../images/rec6.png",
          staffPosition: "Surgical",
          staffView: "view Profile",

     },
     {
          id: 7,
          staffName: "Khalid maha",
          staffImg: "../images/rec5.png",
          staffPosition: "Genral",
          staffView: "view Profile",
     },
     {
          id: 8,
          staffName: "Richard kayy",
          staffImg: "../images/rec7.png",
          staffPosition: "Gynacology",
          staffView: "view Profile",
          
     },
     {
          id: 9,
          staffName: "Elena jones",
          staffImg: "../images/rec6.png",
          staffPosition: "Surgical",
          staffView: "view Profile",


     },
     
]